import theme from "@mapbox/mapbox-gl-draw/src/lib/theme"


const newStyles = [
	{
		'id': 'gl-draw-polygon-midpoint',
		'type': 'circle',
		'filter': ['all',
			['==', '$type', 'Point'],
			['==', 'meta', 'midpoint']],
		'paint': {
			'circle-radius': 4,
			'circle-color': '#fbb03b'
		}
	}
]

let merged = theme;
console.log(merged)
for(const style of newStyles) {
	for(let i=0 ; i<merged.length; i++) {
		console.log(merged[i])
		if(merged[i].id == style.id) {
			merged.splice(i, 1, style)
		}
	}
}

export default merged;